import { Component } from '@angular/core';


/* istanbul ignore next */
/* Code coverage having problems with no statements in classes */
export class SkyPageSummaryStatusComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-page-summary-status',
  template: `<div class="sky-page-summary-status">
  <ng-content></ng-content>
</div>
`,
  styles: [`.sky-page-summary-status {
  margin-top: 10px;
}

.sky-page-summary-status /deep/ .sky-label {
  margin-right: 5px;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
